import React from 'react';

export default {
  not_found: () => (
    <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
      <p className="error">An error occurred</p>
    </div>
  ),
};